var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../form.html"] = require( "../form.html" );
dependencies["../../elements/combobox.html"] = require( "../../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/modals/modalDimensionObjectSelector.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../form.html", false, "views/content/modals/modalDimensionObjectSelector.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\r\n";
env.getTemplate("../../elements/combobox.html", false, "views/content/modals/modalDimensionObjectSelector.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("combo", t_4);
output += "\r\n\r\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"DimensionObjectSelectorDialog")) {
output += "\r\n\t<div class=\"modal-header\">\r\n\t\t<h4 class=\"modal-title\" id=\"modalLable\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"DimensionObjectSelectorDialog"), env.opts.autoescape);
output += "</h5>\r\n\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\r\n\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t</button>\r\n\t</div>\r\n";
;
}
output += "\r\n<div id=\"modalSelectDimensionObject\" name = \"modalSelectDimensionObject\">\r\n\t<form class=\"grid ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "simple")?"simple":""), env.opts.autoescape);
output += "\" id=\"selectPersonForm\" name=\"modalDimensionObjectSelectorDialog\">\r\n\t\t<div class=\"modal-body\">\r\n\t\t\t<div class=\"container-fluid\">\r\n\t\t\t\t<div id=\"notifyDialog\" style=\"display:none;\" class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\r\n\t\t\t\t\t<span id=\"notifyDialogContent\"></span>\r\n\t\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\r\n\t\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t\t\t\t</button>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t<div class=\"col-12\">\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dimensionObject")),"DimensionObjectID")) {
output += "\r\n\t\t\t\t\t\t\t<h4>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalDimensionObjectSelectorSelectedPerson"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "description"), env.opts.autoescape);
output += "</h4>\r\n\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t<h4>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalDimensionObjectSelectorNewPerson"), env.opts.autoescape);
output += "</h4>\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t<hr>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-12 col-md-8\">\r\n\t\t\t\t\r\n\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "columns")) {
output += "\r\n\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_9 = runtime.contextOrFrameLookup(context, frame, "columns");
if(t_9) {var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("col", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += "\r\n\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_10),"IsVisible") && runtime.memberLookup((t_10),"Ranking") > 0) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 col-xs-12 col-md-4\">\r\n\t\t\t\t\t\t\t\t\t\t\t<label class=\"form-field\" ";
if(runtime.memberLookup((t_10),"Type") == "Boolean") {
output += " ";
;
}
output += ">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-label text-left\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Title"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_10),"IsRequired")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"required-indicator\" title=\"\">*</span>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_10),"combobox")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-input combobox-scan\" id=\"parentDimensionObjectSelector\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 47, colno = 38, runtime.callWrap(runtime.memberLookup((t_4),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),runtime.memberLookup((t_10),"combobox")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
else {
if(runtime.memberLookup((t_10),"Type")) {
output += "\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"form-input required-field ";
output += runtime.suppressValue((runtime.memberLookup((t_10),"Type") == "Money"?"money":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "null");
frame.set("initialValue", t_11, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_11);
}
if(frame.topLevel) {
context.addExport("initialValue", t_11);
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_10),"Initial")) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((t_10),"Initial")),"Value");
frame.set("initialValue", t_12, true);
if(frame.topLevel) {
context.setVariable("initialValue", t_12);
}
if(frame.topLevel) {
context.addExport("initialValue", t_12);
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 57, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_10,runtime.memberLookup((t_10),"Type"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dimensionObject")),runtime.memberLookup((t_10),"Name")),runtime.memberLookup((t_10),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 61, colno = 35, runtime.callWrap(runtime.memberLookup((t_1),"createInputField"), "form[\"createInputField\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session"),t_10,runtime.memberLookup((t_10),"Type"),runtime.memberLookup((t_10),"Value"),runtime.memberLookup((t_10),"Initial"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "window")])), env.opts.autoescape);
output += "\r\n\r\n\t\t\t\t\t\t\t\t\t\t\t\t";
;
}
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "type") == "choice") {
output += "\r\n\t\t\t\t\t\t\t\t\t\t<select name=\"choice\">\r\n\t\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_15 = runtime.contextOrFrameLookup(context, frame, "args");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("option", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t<option>";
output += runtime.suppressValue(t_16, env.opts.autoescape);
output += "</option>\r\n\t\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\t\t";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "date") {
output += "\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"date-picker\">\r\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"givendate\" autocomplete=\"no\" class=\"editable-text date\">\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t";
;
}
;
}
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t";
output += "\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"col-12 col-md-4\" id=\"containerHolder\">\r\n\t\t\t\t\t\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<!-- /row -->\r\n\t\t\t</div>\r\n\t\t\t<!-- /container -->\r\n\t\t</div>\r\n\t\t<div class=\"modal-footer\">\r\n\t\t\t<div class=\"actions-left\">\r\n\t\t\t\t<button class=\"btn btn-primary\" id=\"findRelevantDimensionObjects\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalDimensionObjectSelectorSearch"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t<button class=\"btn btn-secondary\" id=\"clearDimensionObjectForm\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalDimensionObjectSelectorClearForm"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"spinner actions-left\" style=\"display: none;\"></div>\t\r\n\t\t\t<div class=\"msg-actions actions-right text-\">\r\n\t\t\t\t<button class=\"btn btn-default button-menu mr-auto\" data-dismiss=\"modal\" data-close>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Close"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t<button class=\"btn btn-primary button-menu mr-auto\" id=\"addDimensionObject\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ModalDimensionObjectSelectorAdd"), env.opts.autoescape);
output += "</button>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</form>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/modals/modalDimensionObjectSelector.html"] , dependencies)